/**
 * Created by dushyantha on 10/10/16.
 */
(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name trainingSchedule.directive:trainingScheduleSearch
     * @restrict EA
     * @element
     *
     */
    angular
        .module('trainingSchedule')
        .directive('trainingScheduleSearch', trainingScheduleSearch)
        .directive('focusOn',function($timeout) {
    		return {
    			restrict : 'A',
    			link : function(vm,$element,$attr) {
    				vm.$watch($attr.focusOn,function(_focusVal) {
    					$timeout(function() {
    						_focusVal ? $element[0].focus() :
    							$element[0].blur();
                    	});
                	});
            	}
    		}
    	});


    function trainingScheduleSearch(MessageService,applicationConstants) {
        return {
            restrict: 'EA',
            scope: {
            	changeSearchField:'&',
                onSearchTrainingSchedule:'&',
                aircraftTypes:'=',
                trainingCategories:'=',
                showSearchArea:'=',
                trainingCrewType:'=',
                trainingProgramCode:'=',
                trainingLocation:'=',
                trainersList:'=',
                traineesList:'='

            },
            templateUrl: 'training-schedule/directives/training-schedule-search-directive.tpl.html',
            replace: false,
            controllerAs: 'trainingScheduleSearch',
            bindToController: true,
            controller: [ function () {
                var vm = this;
                vm.showSearchArea = true;
                vm.model ={
                    startDate : "",
                    endDate : "",
                    aircraftModelDetails :{model:''},
                    trainingProCategoryDetails:{categoryCode:''},
                    trainingCrewTypeDetails:{crewTypeCode:''},
                    trainingProgramCodeDetails:{programCode:''},
                    trainingLocationDetails:{locationCode:''},
                    trainerDetails:{crewId:''},
                    traineeDetails:{crewId:''}
                };

              setDefaultSearchDays();

                vm.displaySearchArea = function () {
                    vm.showSearchArea = !vm.showSearchArea;
                   // vm.openSearchPanel();
                };

                vm.changeDate = function (flag) {
                	var tempFromDate = moment(vm.model.startDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
                	if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
                		vm.model.endDate = tempFromDate;
                	}
                    if((flag.toUpperCase()==='FROMDATE') &&
                  		  (!!vm.model.endDate && !!vm.model.startDate)){
                        var fD = moment(vm.model.startDate, applicationConstants.SETTINGS.DATE_FORMAT);
                        var eD = moment(vm.model.endDate, applicationConstants.SETTINGS.DATE_FORMAT);
                        if(eD.diff(fD) < 0){
                            vm.model.endDate = vm.model.startDate;
                        }
                    }
                  };

                  vm.changeField = function(flag){
                	  vm.changeSearchField({searchParam:vm.model});
                  }

              function setDefaultSearchDays(){
                if(!vm.model.startDate){
                  var moStart = moment().startOf("month");
                  var moEnd = moment().endOf("month");
                  vm.model.startDate = moStart.format(applicationConstants.SETTINGS.DATE_FORMAT);
                  vm.model.endDate = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
                }
              }


                  vm.changeToDate = function (flag,date) {
                	  vm.model.endDate = date;
                  };

                vm.onSearchClick = function () {
                    vm.onSearchTrainingSchedule({searchParam:vm.model});
                };

              console.log(vm.trainingCategories);
              console.log(vm.trainingCrewType);

            }],

            link: function (scope, element, attrs) {

            }


        };
    }
}());
